import ChapterElement from "./ChapterElement";
import { ChapterGroupElementProps } from "./types";

const ChapterElementGroup = ({ value }: ChapterGroupElementProps) => {
  return (
    <div className="chapter-element-group">
      {value.map((chapter, index) => (
        <div key={`${chapter.title}-${index}`}>
          <ChapterElement value={chapter} />
        </div>
      ))}
    </div>
  );
};

export default ChapterElementGroup;
